import { FC, Fragment } from "react"
import { Popover, Transition } from "@headlessui/react"
import { Settings2 } from "lucide-react"
import { ColumnFiltersState } from "@tanstack/react-table"
import GenericMultiToggle from "../../table/toolbar/GenericMultiToggle"

interface DreamRateFiltersProps {
  columnID: string
  columnFilters: ColumnFiltersState
  setColumnFilters: (
    filters:
      | ColumnFiltersState
      | ((prev: ColumnFiltersState) => ColumnFiltersState)
  ) => void
  className?: string
  shrinkFilter?: boolean
  popoverPlace?: "left" | "right"
  popoverPlaceInMobile?: "left" | "right"
}

const DreamRateFilters: FC<DreamRateFiltersProps> = ({
  columnID,
  columnFilters,
  setColumnFilters,
  className = "flex items-center",
  popoverPlace = "left",
  popoverPlaceInMobile = "left",
  shrinkFilter = false
}) => {
  return (
    <div className={className}>
      <Popover className="relative">
        <Popover.Button className="group inline-flex items-center justify-center appearance-none !px-4 !py-2 border !border-slate-300 !rounded-lg placeholder-gray-400 focus:outline-none hover:bg-primary-50 hover:!border-primary-300 hover:text-primary-600 sm:text-sm">
          <Settings2
            size={16}
            className="flex-shrink-0 text-base-dark group-hover:text-primary-600"
          />
          <span
            className={
              shrinkFilter ? "sr-only sm:not-sr-only ml-1 inline-block" : ""
            }
          >
            Filters
          </span>
        </Popover.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Popover.Panel
            className={`origin-top-right absolute ${
              popoverPlaceInMobile === "left"
                ? "left-0 right-auto"
                : "left-auto right-0"
            } ${
              popoverPlace === "left"
                ? "lg:left-0 lg:right-auto"
                : "lg:left-auto lg:right-0"
            } mt-2 bg-white rounded-md shadow-2xl p-4 ring-1 ring-black ring-opacity-5 focus:outline-none z-10`}
          >
            <h3 className="sr-only">Filter by status and Dream rate</h3>
            <div className="space-y-2">
              <GenericMultiToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="status"
                filterValue="active"
                label="Active"
              />
              <GenericMultiToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="status"
                filterValue="pending"
                label="Pending"
              />
              <GenericMultiToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="status"
                filterValue="cancelled"
                label="Cancelled"
              />
              <GenericMultiToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="desired_rate_range"
                filterValue="3-4"
                label="3-4% Dream rate"
              />
              <GenericMultiToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="desired_rate_range"
                filterValue="4-5"
                label="4-5% Dream rate"
              />
              <GenericMultiToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="desired_rate_range"
                filterValue="5-6"
                label="5-6% Dream rate"
              />
              <GenericMultiToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="desired_rate_range"
                filterValue="6-7"
                label="6-7% Dream rate"
              />
              <GenericMultiToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="desired_rate_range"
                filterValue="7-8"
                label="7-8% Dream rate"
              />
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
    </div>
  )
}

export default DreamRateFilters
